import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import { GlobalStyle } from "../../assets/styles/GlobalStyles";

// views
import StepOne from "../../views/StepOne";

// components
import { Layout } from "../../components/Layout";
import StepTwo from "../../views/StepTwo";
import StepThree from "../../views/StepThree";

//context
import { InvoiceProvider } from "store/context";

const App = () => {
  return (
    <>
      <GlobalStyle />
      <HashRouter>
        <InvoiceProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<StepOne />} />
            <Route path="/facturar" element={<StepTwo />} />
            <Route path="/archivos" element={<StepThree />} />
          </Route>
        </Routes>
        </InvoiceProvider>
        
      </HashRouter>
    </>
  );
};

export default App;
